<template>
  <div id="app">
    <!-- 缓存的路由组件 -->
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>

    <!-- 不缓存的路由组件 -->
    <router-view v-if="!($route.meta && $route.meta.keepAlive)" />
  </div>
</template>

<script>
export default {
  methods: {
    // 设置title ico
    setHtmlHead() {
      let name = 'Vava - Live video chat'
      let ico = '/ico/ico-vava.png'

      // echo
      if (this.packageName === 'echo') {
        name = 'Echo - Live video chat'
        ico = '/ico/ico-echo.png'
      }
      // joychat
      if (this.packageName === 'joychat') {
        name = 'Joychat - Live video chat'
        ico = '/ico/ico-joychat.png'
      }
      // joyu
      if (this.packageName === 'joyu') {
        name = 'Joyu - Live video chat'
        ico = '/ico/ico-joyu.png'
      }
      // kiko
      if (this.packageName === 'kiko') {
        name = 'Kiko - Live video chat'
        ico = '/ico/ico-kiko.png'
      }
      // vava
      if (this.packageName === 'vava') {
        name = 'Vava - Live video chat'
        ico = '/ico/ico-vava.png'
      }
      // vibeo
      if (this.packageName === 'vibeo') {
        name = 'Vibeo - Live video chat'
        ico = '/ico/ico-vibeo.png'
      }
      // whonow
      if (this.packageName === 'whonow') {
        name = 'WhoNow - Live video chat'
        ico = '/ico/ico-whonow.png'
      }

      document.getElementsByTagName('title')[0].innerText = name

      const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
      link.href = ico
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  },
  mounted() {
    this.setHtmlHead()
  }
}
</script>
